import React from "react";
import "assets/styles/ecommerce/BenefitsEcommerce.scss";

const BenefitsEcommerce = () => {
  const steps = [
    {
      number: 1,
      title: "¡Iniciemos!",
      description: "Agendamos una llamada para conocer a detalle las necesidades de tu negocio.",
      hasEmoji: false
    },
    {
      number: 2,
      title: "KYC",
      description: "Regístrate en nuestro link y envía tus proyecciones a comercial@etomin.com",
      hasEmoji: false
    },
    {
      number: 3,
      title: "Propuesta",
      description: "Recibe y aprueba una propuesta comercial.",
      hasEmoji: false
    },
    {
      number: 4,
      title: "Contrato",
      description: "Recibe y firma el contrato con Etomin.",
      hasEmoji: false
    },
    {
      number: 5,
      title: "Integración",
      description: "Integración con apoyo del equipo técnico de Etomin.",
      hasEmoji: false
    },
    {
      number: 6,
      title: "Certificación",
      description: "Agendamos una sesión para certificación.",
      hasEmoji: false
    },
    {
      number: 7,
      title: "Pruebas",
      description: "Se realizan pruebas pre producción.",
      hasEmoji: false
    },
    {
      number: 8,
      title: "Bienvenido",
      description: "Salida a productivo.",
      hasEmoji: true
    }
  ];

  return (
    <div className={'benefitsEcommerceWrapper'}>
      <div className={'benefitsEcommerce'}>
        <div className={'processFlow'}>
          {/* Primera fila: pasos 1-4 */}
          <div className={'processRow'}>
            {steps.slice(0, 4).map((step, index) => (
              <div key={step.number} className={'processStep'}>
                <h3 className={'processStepTitle'}>{step.title}</h3>
                <div className={'processStepNumber'}>{step.number}</div>
                <div className={'processStepBox'}>
                  <p>{step.description}</p>
                  {step.hasEmoji && <div className={'processEmoji'}>😊</div>}
                </div>
              </div>
            ))}
          </div>

          {/* Segunda fila: pasos 8-5 (invertido) */}
          <div className={'processRow processRowReverse'}>
            {steps.slice(4, 8).reverse().map((step, index) => (
              <div key={step.number} className={'processStep'}>
                <h3 className={'processStepTitle'}>{step.title}</h3>
                <div className={'processStepNumber'}>{step.number}</div>
                <div className={'processStepBox'}>
                  <p>{step.description}</p>
                  {step.hasEmoji && <div className={'processEmoji'}>😊</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsEcommerce;
